export const appName = "Boom69";
export const globalLink = "https://boom69.com/";
